import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/App";
import "@/styles/index.css";
import { useAuthStore } from "@/stores/useAuthStore";
import { installStaleChunkRecovery } from "@/lib/staleChunkRecovery";
import { router } from "@/router";
import { registerNavigate } from "@/lib/navigation";

// Install global stale-chunk recovery before anything else renders.
// Auto-reloads once on dynamic-import 404 after a deploy; falls back to
// a toast on repeated failure (loop guard via sessionStorage).
installStaleChunkRecovery();

// Wire SPA navigation for non-React modules (apiClient interceptors). Lets the
// forced-change-password redirect happen WITHOUT a full page reload, which would
// otherwise wipe the in-memory access token and 401 the SA on first login.
registerNavigate((path) => {
  void router.navigate(path);
});

// Kick off silent refresh on app mount.
void useAuthStore.getState().hydrateOnMount();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
